import { User } from "../../../model/User/User";
import { apiService } from "../../ApiService";

export type UpdateUserInfoFormData = {
  email?: string;
  firstName?: string;
  lastName?: string;
  birthDate?: string;
  msisdn?: string;
  lang: string;
};

export const updateUserInfo = (user: User, data: UpdateUserInfoFormData) => {
  return apiService.put<{ user: User }>({
    path: `public/user`,
    body: {
      user: {
        ...user,
        ...data,
      },
    },
    requiresAuthPolicy: "user",
    crm: true,
  });
};
